import { useState } from "react";
import { Play } from "lucide-react";
import { motion } from "framer-motion";
import Lightbox, { getVideoEmbed } from "@/components/Lightbox";
import { Reveal, Overline } from "@/components/motion";

const BENTO = [
  "md:col-span-2 md:row-span-2",
  "",
  "",
  "md:col-span-2",
  "",
  "",
  "md:col-span-2",
  "",
];

const Gallery = ({ items, title = "Nos anciens stages", overline = "Galerie", testId = "gallery" }) => {
  const [selected, setSelected] = useState(null);
  if (!items.length) return null;

  return (
    <section data-testid={testId} className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
      <Reveal>
        <Overline>{overline}</Overline>
        <h2 className="mt-4 font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.9] tracking-tight">
          {title}
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 auto-rows-[200px] md:auto-rows-[230px] gap-4">
        {items.map((item, i) => (
          <Reveal key={item.id || i} delay={i * 0.05} y={30} className={BENTO[i % BENTO.length]}>
            <motion.button
              data-testid={`gallery-item-${i}`}
              onClick={() => setSelected(i)}
              whileHover="hover"
              className="relative w-full h-full overflow-hidden group text-left"
            >
              {item.media_type === "video" && getVideoEmbed(item.url)?.kind === "mp4" ? (
                <motion.video
                  src={item.url}
                  muted
                  playsInline
                  preload="metadata"
                  variants={{ hover: { scale: 1.06 } }}
                  transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                  className="w-full h-full object-cover"
                />
              ) : (
                <motion.img
                  src={item.url}
                  alt={item.titre}
                  loading="lazy"
                  variants={{ hover: { scale: 1.06 } }}
                  transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                  className="w-full h-full object-cover"
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/85 via-transparent to-transparent opacity-70 group-hover:opacity-100 transition-opacity duration-500" />
              {item.media_type === "video" && (
                <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-14 h-14 rounded-full border-2 border-gold text-gold flex items-center justify-center bg-black/40 backdrop-blur-sm">
                  <Play size={22} className="ml-0.5" />
                </span>
              )}
              <span className="absolute bottom-4 left-4 right-4 text-sm font-semibold text-white translate-y-2 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                {item.titre}
              </span>
              <span className="absolute inset-0 border border-transparent group-hover:border-gold/60 transition-colors duration-500" />
            </motion.button>
          </Reveal>
        ))}
      </div>

      <Lightbox items={items} index={selected} onClose={() => setSelected(null)} onNavigate={setSelected} />
    </section>
  );
};

export default Gallery;
